import { Root } from '@components/app/Root'
import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext } from '@tanstack/react-router'
import type { HostMode } from '@godalming/api-types'

type AuthStatus = 'unknown' | 'authed' | 'guest'

type RouterAuthContext = {
    hostMode: HostMode
    status: AuthStatus
    ensureAuth: () => Promise<{ status: AuthStatus }>
}

interface RouterContext {
    queryClient: QueryClient
    auth: RouterAuthContext
}

export const Route = createRootRouteWithContext<RouterContext>()({
    component: Root,
})
